import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {required,email,isValidForm} from '../../../server/validationMethods.js'
import Draft from './draft.js';


class MigrantQualify extends Component {
    constructor(props){
        super(props);
        this.state={
            hasError:false,
            hasOptionError:false
        }
        this.validateStudents=this.validateStudents.bind(this);
        
    }
  
    validateStudents=()=>{
        let someSelected=this.props.lunchObj.studentList.some(function (e) {
            if(e.isSelected){
                if((e.runaway||e.migrantEducationPrg||e.mcKinneyVentoHomeless||e.headStart)===true){
                    return true
                }
                else{
                    return false
                }
            }
        });
        return someSelected
    }
render(){
   
    return(
        <div>
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="schoolInfo">
                        <p><strong><Trans>Your children can also qualify for free meals if any one of these apply</Trans>.</strong></p>
                    </div>
                </div>
            </div> 
            <div className="row">
                <div className="col-md-12">
                    <p>
                    { (!this.validateStudents()) && this.state.hasError? <span className="text-danger"> <Trans>Please select all required information</Trans>.</span>:null
                    }</p>
                </div>
            </div>           
            {/* {
                this.props.lunchObj.studentList.map((student,m)=>{
                    if(student.isSelected && student.liveUnderFosterCare===false){
                     return <div className="row">
                         <div className="col-md-12">
                                <p>Do <strong>{student.lname+' '+student.fname}</strong>  participate in the Migrant Education Program?
                                </p>
                            </div>
                            <div className="col-md-12">
                                <div className="styled-input-container styled-input--rounded">
                                    <ul>
                                        <li>
                                            <div className="styled-input-single col-md-1" style={{padding: '0px 0px 0px 33px'}}>
                                                    <input id={'migrantEducationProgramYes'+m} data-idx={m} name={'migrantEducationProgram'+m} checked={student.migrantEducationProgram===true}
                                                    type='radio' onChange={(e)=>{
                                                        let _idx=e.target.getAttribute('data-idx');
                                                        this.props.onMigrantEducationStatusChange(_idx,e.target.checked?true:false);                                         
                                                    }} /> 
                                                    <label htmlFor={'migrantEducationProgramYes'+m}>
                                                    {'Yes'}</label>
                                            </div>                                            
                                        </li>
                                        <li>
                                            <div className="styled-input-single col-md-12" style={{padding: '0px 0px 0px 33px'}}>
                                                <input id={'migrantEducationProgramNo'+m} data-idx={m} name={'migrantEducationProgram'+m} checked={student.migrantEducationProgram===false}
                                                    type='radio' onChange={(e)=>{
                                                        let _idx=e.target.getAttribute('data-idx');
                                                        this.props.onMigrantEducationStatusChange(_idx,e.target.checked?false:true);                                            
                                                    }} /> 
                                                <label htmlFor={'migrantEducationProgramNo'+m}>
                                                    {'No'}</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>   
                        </div>
                    }
                }) 
            } */}
            {
                this.props.lunchObj.studentList.map((student,k)=>{
                    if(student.isSelected && student.liveUnderFosterCare===false){ 
                     return <div className="row">
                        {(student.runaway===true||student.migrantEducationPrg===true||student.headStart===true)?null:<div>
                         <div className="col-md-12">
                                <p><Trans>Do</Trans> <strong>{student.lname+' '+student.fname}</strong>  <Trans>receive assistance under the McKinney-Vento Homeless Assistance Act?</Trans>
                                </p>
                            </div>
                            <div className="col-md-12">
                                <div className="styled-input-container styled-input--rounded">
                                    <ul>
                                        <li>
                                            <div className="styled-input-single col-md-1" style={{padding: '0px 0px 0px 33px'}}>
                                                    <input id={'mcKinneyVentoHomelessYes'+k} data-idx={k} name={'mcKinneyVentoHomeless'+k} checked={student.mcKinneyVentoHomeless===true}
                                                    type='radio' disabled={student.runaway===true||student.migrantEducationPrg===true||student.mcKinneyVentoHomeless===true||student.headStart===true}
                                                    onChange={(e)=>{
                                                        let _idx=e.target.getAttribute('data-idx');
                                                        this.props.onMcKinneyVentoProgramStatusChange(_idx,e.target.checked?true:false);                                         
                                                    }} /> 
                                                    <label htmlFor={'mcKinneyVentoHomelessYes'+k}>
                                                    <Trans>{'Yes'}</Trans></label>
                                            </div>                                            
                                        </li>
                                        <li>
                                            <div className="styled-input-single col-md-12" style={{padding: '0px 0px 0px 33px'}}>
                                                <input id={'mcKinneyVentoHomelessNo'+k} data-idx={k} name={'mcKinneyVentoHomeless'+k}
                                                disabled={student.runaway===true||student.migrantEducationPrg===true}
                                                 checked={student.mcKinneyVentoHomeless===false}
                                                    type='radio' onChange={(e)=>{
                                                        let _idx=e.target.getAttribute('data-idx');
                                                        this.props.onMcKinneyVentoProgramStatusChange(_idx,e.target.checked?false:true);                                            
                                                    }} /> 
                                                <label htmlFor={'mcKinneyVentoHomelessNo'+k}>
                                                <Trans>{'No'}</Trans></label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div></div>}
                         {(student.runaway===true||student.mcKinneyVentoHomeless===true||student.headStart===true)?null:<div>
                        <div className="col-md-12">
                                <p><Trans>Do</Trans> <strong>{student.lname+' '+student.fname}</strong>  <Trans>participate in the Migrant Education Program?</Trans>
                                </p>
                            </div>
                            <div className="col-md-12">
                                <div className="styled-input-container styled-input--rounded">
                                    <ul>
                                        <li>
                                            <div className="styled-input-single col-md-1" style={{padding: '0px 0px 0px 33px'}}>
                                                    <input id={'migrantEducationPrgYes'+k} data-idx={k} name={'migrantEducationPrg'+k} checked={student.migrantEducationPrg===true}
                                                    type='radio' disabled={student.runaway===true||student.migrantEducationPrg===true||student.mcKinneyVentoHomeless===true||student.headStart===true}
                                                    onChange={(e)=>{
                                                        let _idx=e.target.getAttribute('data-idx');
                                                        this.props.onMigrantEducationStatusChange(_idx,e.target.checked?true:false);                                         
                                                    }} /> 
                                                    <label htmlFor={'migrantEducationPrgYes'+k}>
                                                    <Trans>{'Yes'}</Trans></label>
                                            </div>                                            
                                        </li>
                                        <li>
                                            <div className="styled-input-single col-md-12" style={{padding: '0px 0px 0px 33px'}}>
                                                <input id={'migrantEducationPrgNo'+k} data-idx={k} name={'migrantEducationPrg'+k} checked={student.migrantEducationPrg===false}
                                                    type='radio' disabled={student.runaway===true||student.mcKinneyVentoHomeless===true}
                                                    onChange={(e)=>{
                                                        let _idx=e.target.getAttribute('data-idx');
                                                        this.props.onMigrantEducationStatusChange(_idx,e.target.checked?false:true);                                            
                                                    }} /> 
                                                <label htmlFor={'migrantEducationPrgNo'+k}>
                                                <Trans>{'No'}</Trans></label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div></div>}
                            {(student.migrantEducationPrg===true||student.mcKinneyVentoHomeless===true||student.headStart===true)? null: <div>
                            <div className="col-md-12">
                                <p><Trans>Do</Trans> <strong>{student.lname+' '+student.fname}</strong> <Trans>participate in the Runaway Program?</Trans>
                                </p>
                            </div>
                            <div className="col-md-12">
                                <div className="styled-input-container styled-input--rounded">
                                    <ul>
                                        <li>
                                            <div className="styled-input-single col-md-1" style={{padding: '0px 0px 0px 33px'}}>
                                                    <input id={'runawayYes'+k} data-idx={k} name={'runaway'+k} checked={student.runaway===true}
                                                    type='radio' disabled={student.runaway===true||student.migrantEducationPrg===true||student.mcKinneyVentoHomeless===true||student.headStart===true}
                                                     onChange={(e)=>{
                                                        let _idx=e.target.getAttribute('data-idx');
                                                        this.props.onStudentMigrantStatusChange(_idx,e.target.checked?true:false);                                         
                                                    }} /> 
                                                    <label htmlFor={'runawayYes'+k}>
                                                    <Trans>{'Yes'}</Trans></label>
                                            </div>
                                                                                     
                                        </li>
                                        <li>
                                            <div className="styled-input-single col-md-12" style={{padding: '0px 0px 0px 33px'}}>
                                                <input id={'runawayNo'+k} data-idx={k} name={'runaway'+k} checked={student.runaway===false}
                                                    type='radio' disabled={student.migrantEducationPrg===true||student.mcKinneyVentoHomeless===true}
                                                    onChange={(e)=>{
                                                        let _idx=e.target.getAttribute('data-idx');
                                                        this.props.onStudentMigrantStatusChange(_idx,e.target.checked?false:true);                                            
                                                    }} /> 
                                                <label htmlFor={'runawayNo'+k}>
                                                <Trans>{'No'}</Trans></label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div></div>}
                            {(student.runaway===true||student.migrantEducationPrg===true||student.mcKinneyVentoHomeless===true)? null: <div>
                            <div className="col-md-12">
                                <p><Trans>Do</Trans> <strong>{student.lname+' '+student.fname}</strong> <Trans>participate in the Head Start Program?</Trans>
                                </p>
                            </div>
                            <div className="col-md-12">
                                <div className="styled-input-container styled-input--rounded">
                                    <ul>
                                        <li>
                                            <div className="styled-input-single col-md-1" style={{padding: '0px 0px 0px 33px'}}>
                                                    <input id={'headStartYes'+k} data-idx={k} name={'headStart'+k} checked={student.headStart===true}
                                                    type='radio' disabled={student.runaway===true||student.migrantEducationPrg===true||student.mcKinneyVentoHomeless===true||student.headStart===true}
                                                     onChange={(e)=>{
                                                        let _idx=e.target.getAttribute('data-idx');
                                                        this.props.onHeadStartStatusChange(_idx,e.target.checked?true:false);
                                                    }} />
                                                    <label htmlFor={'headStartYes'+k}>
                                                    <Trans>{'Yes'}</Trans></label>
                                            </div>

                                        </li>
                                        <li>
                                            <div className="styled-input-single col-md-12" style={{padding: '0px 0px 0px 33px'}}>
                                                <input id={'headStartNo'+k} data-idx={k} name={'headStart'+k} checked={student.headStart===false}
                                                    type='radio' disabled={student.migrantEducationPrg===true||student.mcKinneyVentoHomeless===true||student.runaway===true}
                                                    onChange={(e)=>{
                                                        let _idx=e.target.getAttribute('data-idx');
                                                        this.props.onHeadStartStatusChange(_idx,e.target.checked?false:true);
                                                    }} />
                                                <label htmlFor={'headStartNo'+k}>
                                                <Trans>{'No'}</Trans></label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div></div>}
                        </div>
                    }
                }) 
            }
            
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(5)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{                       
                           /*  if(!this.validateStudents()){
                                this.setState({hasError:true})
                            }else{ */
                                let homelessList=this.props.lunchObj.studentList.filter((student)=>{
                                    return (student.isSelected && student.liveUnderFosterCare===false)
                                });
                                
                               let selectEvery= homelessList.every((student)=>{
                                    return (student.runaway===true||student.migrantEducationPrg===true||student.mcKinneyVentoHomeless===true||student.headStart===true)})
                                if(selectEvery){
                                    this.props.jumpToStep(7);
                                }else{
                                    this.props.jumpToStep(8)
                                } 
                            //}
                    }}>
                        <Trans>Continue</Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} isDistrict={this.props.isDistrict} />
                </div>
            </div>
        </div>
    )
}
}
export default MigrantQualify;


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/migrantQualify.jsx